import { action } from "typesafe-actions";
import { IAuction, IAuctionLinkedProduct, IAuctionProduct } from "./auction.types";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { ERROR_MESSAGES } from "../../constants/enums";
import { makeApiCall } from "../../helpers/postRequest";
import { uploadMultipleFile } from "../../components/FileUpload/utils";
import { IFileUpload } from "../../components/FileUpload/FileUpload.type";
import { getUniqueId } from "../../helpers";

export const FETCH_AUCTION_LIST_PROGRESS = "FETCH_AUCTION_LIST_PROGRESS";
export const FETCH_AUCTION_LIST_SUCCESS = "FETCH_AUCTION_LIST_SUCCESS";
export const FETCH_AUCTION_LIST_FAILED = "FETCH_AUCTION_LIST_FAILED";

export const fecthAuctionListProgress = () =>
  action(FETCH_AUCTION_LIST_PROGRESS);
export const fecthAuctionListSuccess = (
  data: IAuction[],
  totalRecords: number
) => action(FETCH_AUCTION_LIST_SUCCESS, { data, totalRecords });
export const fecthAuctionListFailed = () => action(FETCH_AUCTION_LIST_FAILED);

export const fetchAuctionListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(fecthAuctionListProgress());
        let finalUrl = `/auction/get-auction?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;

        if (searchValue.length > 0) {
          finalUrl = `/auction/get-auction?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate
            }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;
        }
        if (status !== "-1") {
          finalUrl += "&status=" + status;
        }
        const res = await api.get(finalUrl);
        const data: IAuction[] = res.data.data;
        const totalRecords = res.data.totalRecords;

        dispatch(fecthAuctionListSuccess(data, totalRecords));
      } catch (err: any) {
        dispatch(fecthAuctionListFailed());
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      }
    };

export const FETCH_AUCTION_PROGRESS = "FETCH_AUCTION_PROGRESS";
export const FETCH_AUCTION_SUCCESS = "FETCH_AUCTION_SUCCESS";
export const FETCH_AUCTION_FAILED = "FETCH_AUCTION_FAILED";

export const fetchAuctionProgress = () => action(FETCH_AUCTION_PROGRESS);
export const fetchAuctionSuccess = (data: IAuction) =>
  action(FETCH_AUCTION_SUCCESS, { data });
export const fetchAuctionFailed = (errorMessage: string) =>
  action(FETCH_AUCTION_FAILED, { errorMessage });

export const fetchAuctionsAsync =
  (uuid: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(fetchAuctionProgress());
        const res = await api.get(`/auction/get-auction?auction_uuid=${uuid}`);
        const data: IAuction[] = res.data.data;
        if (data.length > 0) {
          dispatch(fetchAuctionSuccess(data[0]));
        } else {
          dispatch(fetchAuctionFailed(ERROR_MESSAGES.NO_RECORD_FOUND));
        }
      } catch (err: any) {
        dispatch(fetchAuctionFailed(ERROR_MESSAGES.SERVER_ERROR));
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      }
    };

export const upsertAuction =
  (
    data: IAuction,

    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(saveLoaderProgress());

        await makeApiCall(
          {
            url: "/auction/upsert-auction",
            method: "POST",
          },
          {},
          {
            ...data,
          }
        );

        dispatch(
          showMessage({
            type: "success",
            message: "Auction created successfully",
            displayAs: "snackbar",
          })
        );
        onCallback(true);
      } catch (err: any) {
        onCallback(false);
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      } finally {
        dispatch(saveLoaderCompleted());
      }
    };

/**------ */

export const FETCH_AUCTION_PRODUCTS_LIST_PROGRESS =
  "FETCH_AUCTION_PRODUCTS_LIST_PROGRESS";
export const FETCH_AUCTION_PRODUCTS_LIST_SUCCESS =
  "FETCH_AUCTION_PRODUCTS_LIST_SUCCESS";
export const FETCH_AUCTION_PRODUCTS_LIST_FAILED =
  "FETCH_AUCTION_PRODUCTS_LIST_FAILED";

export const fecthAuctionProductsListProgress = () =>
  action(FETCH_AUCTION_PRODUCTS_LIST_PROGRESS);
export const fecthAuctionProductsListSuccess = (
  data: IAuctionProduct[],
  totalRecords: number
) => action(FETCH_AUCTION_PRODUCTS_LIST_SUCCESS, { data, totalRecords });
export const fecthAuctionProductsListFailed = () =>
  action(FETCH_AUCTION_PRODUCTS_LIST_FAILED);

export const fetchAuctionProductsListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    status?: string,
    date?: IDataTableV2DateState["dates"],
    searchValue?: IDatatableV2AdvancedSearchFilter,
    columns?: string[],
    value?: string,
    link_status?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fecthAuctionProductsListProgress());
      let url = `/auction/get-auction-product?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}`;
      if (date) {
        url+=`&from_date=${date.fromDate}&to_date=${date.toDate}`
      }

      if (searchValue && searchValue.length > 0) {
        url += `&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      // if (status !== "-1") {
      //   url += `&status=${status}`;
      // }
      if (columns && columns.length > 0 && value && value !== "-1") {
        url += `&columns=${columns}&value=${value}`;
      }
      if (link_status && link_status !== "-1") {
        url += `&link_status=${link_status}`;
      }
      const res = await api.get(url);
      const data: IAuctionProduct[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fecthAuctionProductsListSuccess(data, totalRecords));
      return data;
    } catch (err: any) {
      dispatch(fecthAuctionProductsListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const FETCH_AUCTION_PRODUCT_PROGRESS = "FETCH_AUCTION_PRODUCT_PROGRESS";
export const FETCH_AUCTION_PRODUCT_SUCCESS = "FETCH_AUCTION_PRODUCT_SUCCESS";
export const FETCH_AUCTION_PRODUCT_FAILED = "FETCH_AUCTION_PRODUCT_FAILED";

export const fetchAuctionProductsProgress = () =>
  action(FETCH_AUCTION_PRODUCT_PROGRESS);
export const fetchAuctionProductsSuccess = (data: IAuctionProduct) =>
  action(FETCH_AUCTION_PRODUCT_SUCCESS, { data });
export const fetchAuctionProductsFailed = (errorMessage: string) =>
  action(FETCH_AUCTION_PRODUCT_FAILED, { errorMessage });

export const fetchAuctionsProductsAsync =
  (uuid: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(fetchAuctionProductsProgress());
        const res = await api.get(
          `/auction/get-auction-product?auction_product_uuid=${uuid}`
        );
        const data: IAuctionProduct[] = res.data.data;
        if (data.length > 0) {
          // const attachments: IFileUpload[] = [];
          // for (const item of (data[0].product_images || []) as any) {
          //   attachments.push({
          //     file: null,
          //     key: getUniqueId(),
          //     path: item,
          //   });
          // }
          dispatch(
            fetchAuctionProductsSuccess(data[0])
          );
        } else {
          dispatch(fetchAuctionProductsFailed(ERROR_MESSAGES.NO_RECORD_FOUND));
        }
      } catch (err: any) {
        dispatch(fetchAuctionProductsFailed(ERROR_MESSAGES.SERVER_ERROR));
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      }
    };

export const upsertAuctionProducts =
  (
    data: IAuctionProduct,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(saveLoaderProgress());

        // const asPayload = {};

        // const { paths } = await uploadMultipleFile(
        //   data.product_images || [],
        //   "TEST",
        //   asPayload
        // );

        await makeApiCall(
          {
            url: "/auction/upsert-auction-product",
            method: "POST",
          },
          {},
          {
            ...data,
            // product_images: paths,
          }
        );

        dispatch(
          showMessage({
            type: "success",
            message: "Auction product created successfully",
            displayAs: "snackbar",
          })
        );
        onCallback(true);
      } catch (err: any) {
        onCallback(false);
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      } finally {
        dispatch(saveLoaderCompleted());
      }
    };



export const upsertAuctionProductFilesV2Async =
  (data: IFileUpload[], onCallback: (isSuccess: boolean, data?: string[]) => void): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(saveLoaderProgress());
        const { paths } = await uploadMultipleFile(data || [], "TEST", {});

        dispatch(
          showMessage({
            type: "success",
            message: "Images Uploaded Successfully...!",
            displayAs: "snackbar",
          })
        );
        onCallback(true, paths as string[]);
      } catch (err: any) {
        onCallback(false);
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      } finally {
        dispatch(saveLoaderCompleted());
      }
    };


/**------------ */

export const FETCH_AUCTION_LINKED_PRODUCTS_LIST_PROGRESS = "FETCH_AUCTION_LINKED_PRODUCTS_LIST_PROGRESS";
export const FETCH_AUCTION_LINKED_PRODUCTS_LIST_SUCCESS = "FETCH_AUCTION_LINKED_PRODUCTS_LIST_SUCCESS";
export const FETCH_AUCTION_LINKED_PRODUCTS_LIST_FAILED = "FETCH_AUCTION_LINKED_PRODUCTS_LISTFAILEDS";

export const fecthAuctionLinkedProductsListProgress = () =>
  action(FETCH_AUCTION_LINKED_PRODUCTS_LIST_PROGRESS);
export const fecthAuctionLinkedProductsListSuccess = (
  data: IAuctionLinkedProduct[],
  totalRecords: number
) => action(FETCH_AUCTION_LINKED_PRODUCTS_LIST_SUCCESS, { data, totalRecords });
export const fecthAuctionLinkedProductsListFailed = () => action(FETCH_AUCTION_LINKED_PRODUCTS_LIST_FAILED);

export const fetchAuctionLinkedProductsListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(fecthAuctionLinkedProductsListProgress());
        let finalUrl = `/auction/get-auction-linked-products?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;

        if (searchValue.length > 0) {
          finalUrl = `/auction/get-auction-linked-products?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate
            }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;
        }
        if (status !== "-1") {
          finalUrl += "&status=" + status;
        }
        const res = await api.get(finalUrl);
        const data: IAuctionLinkedProduct[] = res.data.data;
        const totalRecords = res.data.totalRecords;

        dispatch(fecthAuctionLinkedProductsListSuccess(data, totalRecords));
      } catch (err: any) {
        dispatch(fecthAuctionLinkedProductsListFailed());
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      }
    };

export const FETCH_AUCTION_LINKED_PRODUCT_PROGRESS = "FETCH_AUCTION_LINKED_PRODUCT_PROGRESS";
export const FETCH_AUCTION_LINKED_PRODUCT_SUCCESS = "FETCH_AUCTION_LINKED_PRODUCT_SUCCESS";
export const FETCH_AUCTION_LINKED_PRODUCT_FAILED = "FETCH_AUCTION_LINKED_PRODUCT_FAILED";

export const fetchAuctionLinkedProductProgress = () => action(FETCH_AUCTION_LINKED_PRODUCT_PROGRESS);
export const fetchAuctionLinkedProductSuccess = (data: IAuctionLinkedProduct) =>
  action(FETCH_AUCTION_LINKED_PRODUCT_SUCCESS, { data });
export const fetchAuctionLinkedProductFailed = (errorMessage: string) =>
  action(FETCH_AUCTION_LINKED_PRODUCT_FAILED, { errorMessage });

export const fetchAuctionsLinkedProductAsync =
  (uuid: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(fetchAuctionLinkedProductProgress());
        const res = await api.get(`/auction/get-auction-linked-products?auction_linked_products_uuid=${uuid}`);
        const data: IAuctionLinkedProduct[] = res.data.data;
        if (data.length > 0) {
          dispatch(fetchAuctionLinkedProductSuccess(data[0]));
        } else {
          dispatch(fetchAuctionLinkedProductFailed(ERROR_MESSAGES.NO_RECORD_FOUND));
        }
      } catch (err: any) {
        dispatch(fetchAuctionLinkedProductFailed(ERROR_MESSAGES.SERVER_ERROR));
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      }
    };

export const upsertAuctionLinkedProduct =
  (
    data: IAuctionLinkedProduct,

    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(saveLoaderProgress());

        await makeApiCall(
          {
            url: "/auction/upsert-auction-linked-products",
            method: "POST",
          },
          {},
          {
            ...data,
          }
        );

        dispatch(
          showMessage({
            type: "success",
            message: "Product linked successfully.",
            displayAs: "snackbar",
          })
        );
        onCallback(true);
      } catch (err: any) {
        onCallback(false);
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      } finally {
        dispatch(saveLoaderCompleted());
      }
    };


export const CLEAR_AUCTION_STATE = "CLEAR_AUCTION_STATE";
export const CLEAR_AUCTION = "CLEAR_AUCTION";
export const clearAuctionState = () => action(CLEAR_AUCTION_STATE);
export const clearAuction = () => action(CLEAR_AUCTION);